/* eslint-disable react/prop-types */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import loadable from '@loadable/component';
import Card from 'gatsby-core-theme/src/components/organisms/cards';

export default (props) => {
  let customCardComponent = null;
  const type = props.module.model_type || props.module.cards_page_type;

  switch (type) {
    case 'tournament':
      customCardComponent = loadable(() => import(`../../../../components/atoms/cards/tournament`));
      break;
    default:
      customCardComponent = null;
  }

  return (
    <Card
      {...props}
      mobileColumns={1}
      desktopColumns={1}
      tabletColumns={1}
      CustomCardComponent={customCardComponent}
    />
  );
};
